import React from 'react';
import './textarea.css';

const Input = (props) => {
  return (
    <div class='input-group'>
      <textarea type='text' required="required" title={props.title} name={props.name} className='input' placeholder=''/>
      <label className='placeholder' required>{props.placeholder}</label>
    </div>
  );
}
export default Input;